module.exports = __webpack_public_path__ + "img/Malibu2.51445872.png";